import React, { useEffect, useState } from "react";
import { Box, List, ListItem, ListItemIcon, Typography } from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import CategoryIcon from "@mui/icons-material/Category";

import {
  Laptop,
  PhoneAndroid,
  Home,
  SportsSoccer,
  DirectionsCar,
  Kitchen,
  Watch,
  Book,
  FitnessCenter,
  ShoppingCart,
} from "@mui/icons-material";
import { styled } from "@mui/material/styles";
import { orange } from "@mui/material/colors";
import { headers } from "../../utils/utils";
const drawerWidth = 240;
const StyledListItem = styled(ListItem)(({ theme, selected }) => ({
  cursor: "pointer",
  backgroundColor: selected ? orange[700] : "transparent",
  fontWeight: selected ? "bold" : "normal",
  borderRadius: "8px",
  padding: "10px 16px",
  margin: "4px 0",
  transition: "background-color 0.3s ease, transform 0.2s",
  "&:hover": {
    backgroundColor: selected ? orange[800] : theme.palette.grey[200],
    transform: "scale(1.05)",
  },
  "& .MuiListItemIcon-root": {
    color: selected ? "white" : theme.palette.text.primary,
  },
  "& .ecom-menu": {
    color: selected ? "white" : theme.palette.text.primary,
    fontSize: "0.95rem",
  },
}));

const Menu = ({ currentCategory, setCurrentCategory }) => {
  const [categories, setCategories] = useState([]);
  const [iconMap, setIconMap] = useState({});
  const [loading, setLoading] = useState(true); // Loading state to track fetching process

  // Fetch icons dynamically based on ChatGPT response
  const categoryChange = (value) => {
    setCurrentCategory(value);
  };

  useEffect(() => {
    loadCategory();
  }, []);

  const loadCategory = async () => {
    const response = await fetch(
      process.env.REACT_APP_SYS_CONFIG_MGMT +
        "/systemConfig/config?name=ItemCategory&active=true",
      {
        method: "GET",
        headers: headers(),
      },
    );

    const data = await response.json();
    const categoriesList = data.map((item) => item.value);

    setCategories(categoriesList);

    if (categoriesList.length > 0) {
      setCurrentCategory(categoriesList[0]); // Set first category as default
    }

    fetchIcons(categoriesList);
  };

  const iconList = [
    Laptop,
    PhoneAndroid,
    Home,
    SportsSoccer,
    DirectionsCar,
    Kitchen,
    Watch,
    Book,
    FitnessCenter,
    ShoppingCart,
  ];

  const fetchIcons = async (categories) => {
    const newIconMap = {};

    categories.forEach((categoryName, index) => {
      const assignedIcon = iconList[index % iconList.length]; // Cycle through icons sequentially
      newIconMap[categoryName] = assignedIcon;
    });

    setIconMap(newIconMap);
    setLoading(false);
  };
  if (loading) {
    return (
      <div className="ecom-menu" style={{ display: "flex", margin: "20px" }}>
        <Box
          sx={{
            textAlign: "center",
            padding: "16px",
            height: "90%",
            width: "200px",
            position: "fixed",
            zIndex: 10,
            backgroundColor: "#f8f9fa",
            borderBottom: "2px solid #e0e0e0",
            borderRadius: "8px",
            boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
          }}
        >
          <Typography variant="h6">Loading</Typography>
        </Box>
      </div>
    );
  }

  return (
    <div className="ecom-menu" style={{ display: "flex", margin: "20px" }}>
      <Box
        sx={{
          textAlign: "center",
          padding: "16px",
          height: "90%",
          width: "200px",
          position: "fixed",
          zIndex: 10,
          backgroundColor: "#f8f9fa",
          borderBottom: "2px solid #e0e0e0",
          borderRadius: "8px",
          boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
        }}
      >
        <Typography component="div" fontWeight="bold" color="#262626">
          eVyoog
        </Typography>
        <hr className="hr" />

        <Typography
          component="div"
          variant="button"
          fontWeight="bold"
          color="gray"
        >
          categories
        </Typography>
        <List>
          {categories.map((category) => (
            <StyledListItem
              key={category}
              onClick={() => categoryChange(category)}
              selected={currentCategory === category}
            >
              <ListItemIcon>
                {React.createElement(iconMap[category] || CategoryIcon)}
              </ListItemIcon>
              <div className="ecom-menu">{category}</div>
            </StyledListItem>
          ))}
        </List>
      </Box>

      <main
        style={{
          flexGrow: 1,
          padding: "24px",
          marginLeft: drawerWidth,
        }}
      ></main>
    </div>
  );
};

export default Menu;
